export default __webpack_public_path__ + "static/media/slide4.70216cd6.jpeg";